// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__gsbPI","link":"footer_link__2NRxd"};